import React from 'react';
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import constants from '@shared-styles/constants.module.scss';
import SkeletonWrapper from '../skeleton/SkeletonWrapper';
import NotEnoughDataMessage from '../NotEnoughDataMessage';
import { getXAxisLabel, getYAxisLabel } from '../GraphLabels';

const buildPracticeData = practiceArea => {
  if (!practiceArea) {
    return [];
  }
  return practiceArea.AggregatePercentage;
};

/**
 * @typedef {object} AggregatePercentageGraphProps
 * @property {Object} [practiceArea]
 * @property {boolean} loading
 */

/**
 * @param {AggregatePercentageGraphProps} props
 */
const AggregatePercentageGraph = props => {
  const { practiceArea, loading } = props;
  const data = buildPracticeData(practiceArea);
  const resultsCount = data.map(a => a.Results);
  const total = resultsCount.reduce((a, b) => a + b, 0);

  return (
    <div className='baseline-graph aggregate-percentage-graph'>
      <SkeletonWrapper
        show={loading}
        renderComponent={() => (
          <>
            {total <= 2 ? <NotEnoughDataMessage /> : null}
            <ResponsiveContainer width='95%' height={350}>
              <ComposedChart
                layout='vertical'
                data={data}
                margin={{
                  top: 20,
                  right: 20,
                  left: 40,
                  bottom: 20
                }}>
                <CartesianGrid stroke='#f5f5f5' />
                <XAxis type='number' allowDecimals={false}>
                  {getXAxisLabel('# Appraisals containing PA')}
                </XAxis>
                <YAxis dataKey='Name' type='category' scale='band'>
                  {getYAxisLabel('Aggregate PA % Distribution in Quintiles', 50, 20)}
                </YAxis>
                <Legend wrapperStyle={{ paddingTop: '1.5rem' }} align='center' />
                <Tooltip />
                {total >= 3 ? (
                  <Bar dataKey='Results' barSize={20} fill={constants.industryColor} />
                ) : null}
              </ComposedChart>
            </ResponsiveContainer>
          </>
        )}
      />
    </div>
  );
};

export default AggregatePercentageGraph;
